export const keyValueSelector = (index, data) => {
    let curretnValue = { ...data }
    const keys = index.split(".")
    keys.forEach(key => { curretnValue = curretnValue[key] })
    return curretnValue
}